import { Flex, Box, Avatar, Text } from "@chakra-ui/react";
import { useAuth } from "../../hooks/auth";

interface ProfileProps {
  showProfileData: boolean;
}

export function Profile({ showProfileData = true }: ProfileProps) {
  const { user } = useAuth();

  return (
    <Flex align="center" bg="bg" h="20">
      {showProfileData && (
        <Box mr="6" textAlign="right" fontFamily={""}>
          <Text fontSize={"19px"} lineHeight={"0.4"} color="text">
            {user?.name}
          </Text>
          <Text fontSize={"sm"} color="gray_light">
            {user?.email}
          </Text>
        </Box>
      )}

      <Avatar size="md" mr="2" name={user?.name} />
    </Flex>
  );
}
